module.exports = __webpack_public_path__ + "media/component-library/apple-login-button/copy/en-509fb397f1a1f091603cbad3dd352d8b.svg";